import type { BugsTranslation } from "./en.bugs";

const bugsUz: BugsTranslation = {
  severity: {
    s1: "S1 Jiddiy",
    s2: "S2 Muhim",
    s3: "S3 Kichik",
    s4: "S4 Arzimas",
    short: { s1: "S1", s2: "S2", s3: "S3", s4: "S4" },
    rubric: {
      s1: "Asosiy jarayon ishlamaydi, ma’lumot yo‘qoladi, pul yoki xavfsizlikka ta’sir qiladi, ko‘p foydalanuvchi.",
      s2: "Muhim funksiya buzilgan va oddiy aylanib o‘tish yo‘li yo‘q, yoki ko‘p foydalanuvchiga ta’sir qiladi.",
      s3: "Funksiya yomonroq ishlaydi, aylanib o‘tish yo‘li bor, yoki kam foydalanuvchiga ta’sir qiladi.",
      s4: "Ko‘rinish: matn, joylashuv, kichik UX kamchiliklari.",
    },
  },
  bugPriority: { p0: "P0", p1: "P1", p2: "P2", p3: "P3" },
  bugStatus: {
    reported: "Xabar berilgan",
    triaged: "Saralangan",
    investigating: "O‘rganilmoqda",
    mitigated: "Yumshatilgan",
    fixed: "Tuzatilgan",
    verified: "Tekshirilgan",
    analysis: "Tahlil",
    closed: "Yopilgan",
  },
  resolution: {
    fixed: "Tuzatilgan",
    duplicate: "Takror",
    not_a_bug: "Xato emas",
    wont_fix: "Tuzatilmaydi",
  },
  detectedBy: {
    customer: "Mijoz xabari",
    support: "Qo‘llab-quvvatlash",
    internal: "Ichki foydalanuvchi",
    monitoring: "Monitoring / ogohlantirish",
    qa: "QA",
  },
  rootCause: {
    requirements_misunderstood: "Talablar noto‘g‘ri tushunilgan / noaniq spetsifikatsiya",
    missing_requirement: "Talab tushib qolgan / chegaraviy holat hisobga olinmagan",
    logic_error: "Koddagi mantiqiy xato",
    integration: "Integratsiya / tashqi xizmat / API shartnomasi",
    data: "Ma’lumot muammosi (yomon ma’lumot, migratsiya)",
    configuration: "Sozlama / deploy / muhit",
    performance: "Unumdorlik / masshtablash",
    security: "Xavfsizlik",
    regression: "Regressiya (oldin ishlagan, o‘zgarishdan keyin buzilgan)",
    infrastructure: "Infratuzilma / hosting",
    other: "Boshqa",
  },
  escapePoint: {
    requirements: "Talablar / grooming",
    design_review: "Dizayn / texnik ko‘rib chiqish",
    code_review: "Kod review",
    test_cases_missing: "Test holatlari — hech bir holat buni qamramagan",
    test_execution_missed: "Sinov — holat bor edi, lekin o‘tkazib yuborilgan",
    environment_difference: "Sinov muhiti prodakshndan farq qilgan",
    monitoring: "Monitoring — faqat mijozlardan bilib oldik",
    not_preventable: "Oqilona oldini olib bo‘lmasdi",
  },
  actionKind: {
    regression_test: "Regressiya testi",
    code_fix: "Kodni tuzatish",
    monitoring: "Monitoring / ogohlantirish",
    process: "Jarayon / nazorat ro‘yxati",
    documentation: "Hujjatlar",
    training: "O‘qitish",
  },
  actionStatus: {
    open: "Ochiq",
    in_progress: "Jarayonda",
    done: "Bajarildi",
    cancelled: "Bekor qilindi",
  },
  postmortemStatus: {
    none: "Boshlanmagan",
    draft: "Qoralama",
    approved: "Tasdiqlangan",
  },
  linkKind: {
    related: "Bog‘liq",
    recurrence: "Takrorlanish",
  },
  bugNav: {
    bugs: "Xatolar",
    regression: "Regressiya to‘plami",
    learnings: "Saboqlar",
    openMajor: "Ochiq S1/S2: {{count}}",
  },
  bugs: {
    overdue: "{{time}} kechikdi",
    dueIn: "{{time}} ichida yumshatish kerak",
    title: "Prodakshndagi xatolar",
    showMajor: "Faqat S1/S2",
    majorCallout: "Ochiq S1/S2: {{count}} — bu «Xatolar» belgisidagi son. Avval shularni tuzating.",
    report: "Xato haqida xabar berish",
    search: "Xatolarni qidirish",
    filterOpen: "Ochiq",
    filterAll: "Hammasi",
    filterClosed: "Yopilgan",
    filterSeverity: "Jiddiylik",
    filterStatus: "Holat",
    anyComponent: "Istalgan komponent",
    anyApp: "Istalgan ilova",
    mine: "Meniki",
    empty: "Prodakshnda xato yo‘q",
    emptyBody: "Relizdan keyin biror narsa buzilsa, shu yerda xabar bering — u jiddiylik bo‘yicha kuzatiladi va tahlil qilinadi.",
    noMatch: "Bu filtrlarga mos xato yo‘q.",
    openActions: "Ochiq harakatlar: {{count}}",
    detected: "Aniqlangan: {{time}}",
    unowned: "Mas’ul yo‘q",
    bugN: "BUG-{{n}}",
  },
  report: {
    more: "Batafsil",
    moreHint: "Ustuvorlik, tavsif, ta’sir, vaqt, komponent, mas’ul. Bularning barchasini keyinroq xato sahifasida to‘ldirish mumkin.",
    sectionDetails: "Tafsilotlar",
    title: "Prodakshndagi xato haqida xabar berish",
    intro: "Nima bo‘lganini yozing. Jiddiylik — bu ta’sir; ustuvorlik — tuzatish tartibi.",
    bugTitle: "Nima noto‘g‘ri?",
    titleRequired: "Muammoni bir qatorda yozing.",
    titlePlaceholder: "1 000,00 dan katta karta qaytarishlari «Gateway error 502» bilan tushmoqda",
    similarTitle: "O‘xshash oldingi xatolar — bu takror yoki qayta paydo bo‘lishmi?",
    severity: "Jiddiylik",
    priority: "Ustuvorlik",
    priorityAuto: "Jiddiylikdan olinadi ({{p}}). Faqat sabab bilan o‘zgartiring.",
    detectedBy: "Kim aniqladi",
    component: "Komponent",
    componentPlaceholder: "masalan, Qaytarishlar",
    client: "Mijoz",
    clientPlaceholder: "Foydalanuvchi nomi",
    app: "Ilova",
    foundIn: "Topilgan versiya",
    description: "Tavsif",
    steps: "Takrorlash qadamlari",
    stepsHint: "Enter keyingi qadamni qo‘shadi; bo‘sh qadamda Enter ro‘yxatni tugatadi.",
    attachments: "Skrinshotlar, videolar yoki fayllar",
    attachmentsHint: "Rasm, video, PDF, matn, CSV, JSON yoki ZIP, har biri 100 MB gacha. Skrinshotni joylashtirish ham mumkin (Ctrl/⌘ V).",
    uploading: "Yuklanmoqda {{done}}/{{total}}…",
    uploadFailed: "{{name}} yuklanmadi. Uni xato sahifasida qayta biriktiring.",
    unsupportedFile: "{{name}}: bu turdagi faylni biriktirib bo‘lmaydi (rasm, video, PDF, matn, CSV, JSON yoki ZIP).",
    expected: "Kutilgan natija",
    actual: "Haqiqiy natija",
    impact: "Ta’sir",
    startedAt: "Boshlangan (taxminan)",
    detectedAt: "Aniqlangan",
    originTask: "Qaysi vazifa keltirib chiqargan",
    originHint: "Relizi muammoga sabab bo‘lgan vazifa, masalan PAY-482.",
    owner: "Mas’ul",
    submit: "Xabar berish",
    created: "BUG-{{n}} yaratildi",
    sectionWhat: "Nima bo‘ldi",
    sectionWhen: "Qachon va qayerda",
  },
  impact: {
    title: "Ta’sir",
    users: "Ta’sirlangan foydalanuvchilar",
    customers: "Ta’sirlangan mijozlar",
    money: "Pulga ta’sir",
    moneyPlaceholder: "taxminan 1 200 000 so‘m qo‘lda qaytarildi",
    data: "Ma’lumotlarga ta’sir",
    workaround: "Aylanib o‘tish yo‘li",
    none: "Ta’sir hali yozilmagan.",
  },
  bug: {
    stepOf: "{{total}} tadan {{n}}-qadam",
    nextStep: "keyingisi: {{status}}",
    liveUpdate: "{{name}} bu xatoni yangiladi — sahifa yangilandi.",
    moveTo: "«{{status}}» holatiga o‘tkazish",
    skipTo: "O‘tish…",
    reopen: "Qayta ochish",
    reopenTitle: "BUG-{{n}} qayta ochilsinmi?",
    reopenBody: "U «O‘rganilmoqda» holatiga qaytadi. Tarix tushunarli bo‘lishi uchun sababini yozing.",
    reopenNote: "Nega qayta ochilmoqda?",
    close: "Yopish",
    regressionCase: "Regressiya holatini qo‘shish",
    regressionCreated: "{{key}} regressiya holati regressiya to‘plamiga qo‘shildi",
    regressionLink: "Regressiya holati {{key}}",
    statusChanged: "Holat: {{status}}",
    saved: "Saqlandi",
    closedAs: "Yopilgan · {{resolution}}",
    duplicateOf: "BUG-{{n}} ning takrori",
    details: "Tafsilotlar",
    noDetails: "Hali tafsilot yo‘q.",
    editDetails: "Tafsilotlarni tahrirlash",
    properties: "Xususiyatlar",
    reporter: "Xabar bergan",
    owner: "Mas’ul",
    originTask: "Keltirib chiqargan",
    openTask: "Vazifani Mixlada ochish",
    noValue: "—",
    activity: "Faollik",
    noActivity: "Hali faollik yo‘q.",
    breadcrumb: "Xatolar",
  },
  close: {
    title: "BUG-{{n}} ni yopish",
    resolution: "Yechim",
    duplicateOf: "Asl xato raqami",
    note: "Izoh",
    noteRequired: "Bu yechim uchun sabab kerak.",
    blockersTitle: "«Tuzatilgan» deb yopishdan oldin:",
    submit: "Xatoni yopish",
    closed: "Xato yopildi",
    managersOnly: "Xatolarni faqat loyiha menejerlari yopa oladi.",
  },
  timeline: {
    edit: "Vaqtlarni tahrirlash",
    done: "Tayyor",
    title: "Vaqt chizig‘i",
    started: "Boshlangan",
    detected: "Aniqlangan",
    acknowledged: "Qabul qilingan",
    mitigated: "Yumshatilgan",
    fixed: "Tuzatilgan",
    verified: "Tekshirilgan",
    toDetect: "aniqlashgacha",
    toAcknowledge: "qabul qilishgacha",
    toMitigate: "yumshatishgacha",
    toFix: "tuzatishgacha",
    hint: "Vaqt holat o‘zgarganda belgilanadi. Noto‘g‘ri bo‘lsa, shu yerda tuzating.",
  },
  rca: {
    title: "Asosiy sabab tahlili",
    folded: "Boshlanmagan. Sabab ma’lum bo‘lganda oching.",
    blameless: "Aybdor qidirmaymiz — kim emas, nima bunga yo‘l qo‘yganini so‘raymiz.",
    category: "Asosiy sabab turi",
    escape: "Qayerda ushlashimiz kerak edi?",
    choose: "Tanlang…",
    rootCause: "Asosiy sabab",
    whys: "5 ta nega",
    whyN: "Nega {{n}}",
    root: "Ildiz",
    addWhy: "«Nega» qo‘shish",
    lesson: "Olingan saboq",
    lessonHint: "Faqat saqlashga arziydigan xulosa bo‘lsa. Saboqlar kutubxonasida ko‘rsatiladi.",
  },
  postmortem: {
    title: "Postmortem",
    folded: "Boshlanmagan. Xato tuzatilgach yozing.",
    required: "S1/S2 uchun xatoni yopishdan oldin majburiy.",
    summary: "Qisqacha",
    timeline: "Vaqt chizig‘i",
    trigger: "Sabab bo‘lgan hodisa",
    wentWell: "Nima yaxshi bo‘ldi",
    wentWrong: "Nima noto‘g‘ri ketdi",
    lucky: "Qayerda omadimiz keldi",
    approve: "Tasdiqlash",
    approved: "Postmortem tasdiqlandi",
    approvedBy: "{{name}} tasdiqladi",
    editResets: "O‘zgarishlar saqlansa, tasdiqlangan postmortem qoralamaga qaytadi.",
  },
  actions: {
    title: "Harakatlar",
    empty: "Hali harakat yo‘q. Har bir jiddiy xato kamida bitta harakatga olib kelishi kerak.",
    newTitle: "Nima qilamiz?",
    kind: "Turi",
    owner: "Mas’ul",
    due: "Muddat",
    status: "Holat",
    add: "Qo‘shish",
    added: "Harakat qo‘shildi",
    remove: "Harakatni o‘chirish",
    overdue: "Muddati o‘tgan",
    bug: "Xato",
  },
  comments: {
    feedTitle: "Muhokama va faollik",
    title: "Izohlar",
    empty: "Hali izoh yo‘q.",
    placeholder: "Izoh yozing…",
    send: "Yuborish",
  },
  attachmentsBug: {
    title: "Ilovalar",
    removed: "Ilova o‘chirildi",
    uploaded: "Fayl biriktirildi",
  },
  links: {
    title: "Bog‘liq xatolar",
    empty: "Bog‘liq xato yo‘q.",
    number: "Xato raqami",
    add: "Bog‘lash",
    remove: "BUG-{{n}} bilan bog‘lanishni olib tashlash",
  },
  learnings: {
    title: "Saboqlar",
    tabLibrary: "Kutubxona",
    tabReview: "Ko‘rib chiqish",
    intro: "Yopilgan xatolar va ulardan olingan saboqlar. Xavfli narsani qilishdan oldin shu yerdan qidiring.",
    search: "Saboqlarni qidirish",
    anyCategory: "Istalgan asosiy sabab",
    anyEscape: "Istalgan o‘tkazib yuborish nuqtasi",
    empty: "Hali saboq yo‘q. Ular xato saboq bilan yopilganda paydo bo‘ladi.",
    recurrences: "Takrorlangan: {{count}}",
    closedOn: "Yopilgan: {{time}}",
  },
  review: {
    intro: "Oylik xatolar tahlili uchun: nima ochiq, nimaning muddati o‘tgan, nima hali tahlil qilinmagan.",
    openBySeverity: "Jiddiylik bo‘yicha ochiq xatolar",
    recentMajor: "Oxirgi 30 kundagi S1/S2",
    recentMajorEmpty: "Oxirgi 30 kunda S1/S2 xato bo‘lmadi.",
    missingAnalysis: "Tahlil qilinmagan",
    missingAnalysisEmpty: "Har bir tuzatilgan xatoning asosiy sababi bor.",
    openActions: "Ochiq harakatlar",
    openActionsEmpty: "Ochiq harakat yo‘q.",
  },
  regression: {
    title: "Regressiya to‘plami",
    intro: "Xatolar qaytib kelmasligini ta’minlaydigan holatlar. Ularni oddiy vazifa kabi — raundlar va sinov rejimida o‘tkazing.",
    emptyTitle: "Hali regressiya to‘plami yo‘q",
    emptyBody: "Birinchi xatoga regressiya holati qo‘shilganda u avtomatik yaratiladi, yoki uni hozir yaratishingiz mumkin.",
    create: "Regressiya to‘plamini yaratish",
  },
  components: {
    title: "Komponentlar",
    intro: "Xatolar biriktiriladigan mahsulot qismlari, masalan Qaytarishlar, To‘lov, Hisobotlar.",
    add: "Komponent qo‘shish",
    placeholder: "Yangi komponent",
    rename: "«{{name}}» nomini o‘zgartirish",
    remove: "«{{name}}» ni o‘chirish",
    empty: "Hali komponent yo‘q.",
    saved: "Komponentlar saqlandi",
  },
  closeCheck: {
    title: "Tuzatilgan deb yopish uchun:",
    verified: "Tuzatish tekshirilgan",
    rootCause: "Asosiy sabab",
    escape: "Qayerda ushlanishi kerak edi",
    postmortem: "Postmortem tasdiqlangan",
    ready: "Yopishga tayyor",
  },
  sightings: {
    title: "Qayerda ko‘rilgan",
    empty: "Hozircha kuzatuvlar yo‘q. Kimdir bu xatoni biror versiyada ko‘rganda qo‘shing.",
    seenAgain: "Yana ko‘rildi",
    record: "Kuzatuvni yozish",
    addAnother: "Yana qo‘shish",
    version: "Versiya",
    versionPlaceholder: "Versiyani qidiring yoki yozing",
    versionTextPlaceholder: "Versiyani yozing",
    versionsFailed: "Ilova versiyalarini yuklab bo‘lmadi. Baribir versiyani yozish mumkin.",
    useText: "“{{text}}” matnini ishlatish",
    useTextHint: "Versiya yaratilmaydi",
    linksTo: "{{name}} versiyasiga bog‘lanadi.",
    keptAsText: "Matn sifatida saqlanadi. Ilovada shu nomli versiya paydo bo‘lganda o‘zi bog‘lanadi.",
    keptAsTextNoApp: "Matn sifatida saqlanadi. Loyihada shunday versiyali ilova paydo bo‘lganda bog‘lanishi mumkin.",
    liveHint: "O‘sha paytda ishlagan versiyani olish uchun bo‘sh qoldiring.",
    chooseApp: "Ilovani tanlang",
    noAppChosen: "Noma’lum",
    noApp: "Ilovasiz",
    noApps: "Bu loyihada hali ilova yo‘q, shuning uchun versiyani faqat matn sifatida saqlash mumkin.",
    addApp: "Ilova qo‘shish",
    noAppsAsk: "Bu loyihada hali ilova yo‘q, shuning uchun versiyani faqat matn sifatida saqlash mumkin. Ilovani loyiha menejeri qo‘shishi mumkin.",
    introducedIn: "Paydo bo‘lgan versiya",
    versionUnknown: "Versiya noma’lum",
    inferred: "Avtomatik aniqlangan: o‘sha paytda ishlagan",
    textOnly: "Faqat matn",
    migrated: "Eski maydonlardan",
    reportedAs: "{{text}} deb ko‘rsatilgan",
    onFixVersion: "Xato ochiq, lekin bu versiyada uning tuzatilishi bor.",
    setApp: "Ilovani belgilash",
    makeVersion: "{{name}} versiyasini yaratish",
    outcome: {
      nothing: "",
      expected: "Kutilgan",
      no_fix_here: "Bu ilovada hali tuzatish yo‘q",
      cant_compare: "Taqqoslab bo‘lmaydi, qo‘lda tekshiring",
      evidence: "Belgiga qo‘shildi",
      flagged: "Belgilandi",
    },
    result: {
      nothing: "Kuzatuv yozildi.",
      expected: "Kutilgan: bu versiya tuzatishdan oldin chiqqan.",
      no_fix_here: "Kuzatuv yozildi. Bu ilovada hali tuzatish yo‘q.",
      cant_compare: "Kuzatuv yozildi. Bu versiyani tuzatish bilan taqqoslab bo‘lmaydi, qo‘lda tekshiring.",
      evidence: "Bu versiyada tuzatish bo‘lishi kerak. Regressiya belgisiga dalil sifatida qo‘shildi.",
      flagged: "Regressiya belgilandi: bu versiyada tuzatish bo‘lishi kerak. Mas’ul, xabar bergan va loyiha menejerlariga bildirildi.",
    },
    inferredResult: "O‘sha paytda ishlagan {{name}} versiyasiga bog‘landi.",
    textResult: "“{{text}}” shu nomli versiya paydo bo‘lguncha matn sifatida saqlanadi.",
    bannerTitle: "{{app}}da regressiya bo‘lishi mumkin.",
    bannerBody: "{{version}} versiyasida ko‘rildi, unda {{fix}} tuzatishi bo‘lishi kerak.",
    bannerEvidence: "Keyingi kuzatuvlar: {{count}}.",
    reopen: "Qayta ochish",
    dismiss: "Rad etish",
    reopened: "Xato qayta ochildi",
    dismissed: "Belgi rad etildi",
    reopenTitle: "{{app}} uchun qayta ochish",
    reopenBody: "Xato «O‘rganilmoqda» holatiga qaytadi. Bu {{apps}} uchun ochiq belgilarni hal qiladi va shu ilovalardagi tuzatishlar hisobga olinmaydi.",
    dismissTitle: "{{app}} uchun belgini rad etish",
    dismissBody: "Xato o‘zgarishsiz qoladi. Bu versiyadagi yangi kuzatuvlar faqat dalil qo‘shadi, yuqoriroq versiya esa yangi belgi qo‘yadi.",
    note: "Izoh",
    noteRequired: "Nega qayta ochilayotganini yozing.",
    pastFlags: "Oldingi belgilar",
    flagState: {
      open: "{{app}}: ochiq",
      reopened: "{{app}}: {{name}} qayta ochgan.",
      dismissed: "{{app}}: {{name}} rad etgan.",
    },
    dismissedUntil: "{{version}} dan yuqori versiya ko‘rilguncha amal qiladi.",
  },
  bugActivity: {
    kinds: {
      bug_reported: "xato haqida xabar berdi",
      bug_updated: "xatoni tahrirladi",
      bug_status_changed: "holatni o‘zgartirdi",
      bug_release_changed: "tuzatish versiyalarini o‘zgartirdi",
      bug_closed: "xatoni yopdi",
      bug_reopened: "xatoni qayta ochdi",
      postmortem_approved: "postmortemni tasdiqladi",
      link_added: "xatoni bog‘ladi",
      link_removed: "bog‘lanishni olib tashladi",
      action_item_added: "harakat qo‘shdi",
      action_item_updated: "harakatni yangiladi",
      action_item_removed: "harakatni o‘chirdi",
      comment_added: "izoh qoldirdi",
      regression_case_created: "regressiya holatini qo‘shdi",
      attachment_added: "fayl biriktirdi",
      attachment_removed: "faylni o‘chirdi",
      sighting_added: "xato ko'rinishini qayd etdi",
      sighting_linked: "xato ko'rinishlarini versiyaga bog'ladi",
      sighting_app_set: "xato ko'rinishining ilovasini belgiladi",
      regression_flagged: "regressiyani belgiladi",
      regression_reopened: "regressiyani qayta ochdi",
      regression_dismissed: "regressiyani rad etdi",
      regression_cleared: "endi tegishli bo'lmagan regressiyani olib tashladi",
      gitlab_link_added: "merge request yoki branchni bog‘ladi",
      gitlab_link_confirmed: "merge request yoki branch bog‘lanishini tasdiqladi",
      gitlab_link_removed: "merge request yoki branch bog‘lanishini olib tashladi",
      gitlab_fix_skipped_no_owner: "merge’da xatoni tuzatilgan deb belgilab bo‘lmadi, chunki uning egasi yo‘q",
    },
  },
  inboxBugs: {
    title: "Mening xatolarim",
    empty: "Sizga biriktirilgan ochiq xato yo‘q.",
  },
};

export default bugsUz;
